import { PaginationType } from 'common';
import { CompaniesActionType } from 'enums/CompaniesActionType';
import { CompanyType } from 'state/reducers/companies/types';

export const setCompanies = (companies: CompanyType[]) =>
  ({ type: CompaniesActionType.SET_COMPANIES, companies } as const);

export const setCompaniesAfterScroll = (companies: CompanyType[]) =>
  ({ type: CompaniesActionType.SET_COMPANIES_AFTER_SCROLL, companies } as const);

export const setCertainCompany = (company: CompanyType) =>
  ({ type: CompaniesActionType.SET_CERTAIN_COMPANY, company } as const);

export const searchCompanies = (search: string) =>
  ({ type: CompaniesActionType.SEARCH_COMPANIES, search } as const);

export const setCompaniesLoadingStatus = (isLoading: boolean) =>
  ({ type: CompaniesActionType.SET_COMPANIES_LOADING_STATUS, isLoading } as const);

export const setCompaniesPagination = (pagination: PaginationType) =>
  ({ type: CompaniesActionType.SET_COMPANIES_PAGINATION, pagination } as const);
